import PropTypes from 'prop-types';
import { css } from '@emotion/react';

import Text from 'components/shared/Text/Text';

import FaqQuestion from './FaqQuestion';

const categoryCss = css`
  padding: 25px 0 20px;
`;

function FaqCategory({ categoryTitle, questions = [] }) {
  return (
    <div css={categoryCss}>
      <Text component="h2" fontSize={2.4} fontWeight={500} lineHeight={1.42}>
        {categoryTitle}
      </Text>

      {questions.map(({ answer, question }, i) => (
        <FaqQuestion
          key={`faq-question-${i}`}
          question={question}
          answer={answer}
        />
      ))}
    </div>
  );
}

FaqCategory.propTypes = {
  categoryTitle: PropTypes.string.isRequired,
  questions: PropTypes.array.isRequired,
};

export default FaqCategory;
